export default __webpack_public_path__ + "static/media/news6.c2449241.png";